/**
 * Tracks connectors we optimistically marked as connected after OAuth success,
 * so refetches (e.g. refetchOnWindowFocus) do not overwrite with stale server
 * data until the backend has propagated.
 */
const GRACE_MS = 10000;
const overlay = new Map<string, number>();

export function setOptimisticConnect(outboundAuthUrl: string): void {
  overlay.set(outboundAuthUrl, Date.now());
}

export function isOptimisticallyConnected(outboundAuthUrl: string): boolean {
  const at = overlay.get(outboundAuthUrl);
  if (at == null) {
    return false;
  }
  if (Date.now() - at >= GRACE_MS) {
    clearOptimisticConnect(outboundAuthUrl);
    return false;
  }
  return true;
}

export function clearOptimisticConnect(outboundAuthUrl: string): void {
  overlay.delete(outboundAuthUrl);
}
